const apiPath = {
  loginUser: "/v1/admin/login",
  getUsers: "/v1/admin/user",
  changeUserStatus: "/v1/admin/user/change-status",
  getFAQs: "/v1/admin/faqs",
  getContactUs: "/v1/admin/contact-us",
  changeFAQStatus: "/v1/admin/faqs/status",
  getStaticContent: "/v1/admin/static-content",
  forgotPassword: "/v1/admin/forgot-password",
  resetPassword: "/v1/admin/reset-password",
  changePassword: "/v1/admin/change-password",
  editProfile: "/v1/admin/edit-profile",
  getAllOffers: "/v1/admin/offers",
  getUserDetails: "/v1/admin/user/details",
  getDashboardDetails: "/v1/admin/dashboard",
  subcategoryList: "/v1/admin/subcategory",
  subCategoryStatus: "/v1/admin/subcategory/change-status",
  subcategoryAdd: "/v1/admin/subcategory",
  subcategoryUpdate: "/v1/admin/subcategory",
  categoryManagerList: "/v1/admin/category",
  categoryList: "/v1/admin/category/master-data",
  categoryStatus: "/v1/admin/category/change-status",
  categoryAdd: "/v1/admin/category",
  categoryUpdate: "/v1/admin/category",
  ListBlog: "/v1/admin/blogs",
  ListProduct: "/v1/admin/product",
  addProduct: "/v1/admin/product",
  editProduct: "/v1/admin/product",
  //price
  ListPrice: "/v1/admin/price",
  editPrice: "/v1/admin/price",
  deletePrice: "/v1/admin/price",
  changeStatusBlog: "/v1/admin/blogs/change-status",
  queryList: "/v1/admin/queries",
  notifications: "/v1/admin/notifications",
  //add price
  addPrice: "/v1/admin/price",
  // agrigate new APIs path
  reportContentList: "/v1/admin/help-and-support/report-content",
  reportChangeStatus: "/v1/admin/help-and-support/report-content/change-status",
  contactUsList: "/v1/admin/help-and-support/contact-us/list",
  reasonReportList: "/v1/admin/reason-report",
  reasonReportStatus: "/v1/admin/reason-report/change-status",
  reasonReportAdd: "/v1/admin/reason-report",
  reasonReportUpdate: "/v1/admin/reason-report",
  staticContentPageList: "/v1/admin/static-content/static-pages",
  staticContentPageStatusChange: "/v1/admin/static-content/status-change",
  contactUsReply: "/v1/admin/help-and-support/contact-us/reply",
  deleteBlog: "/v1/admin/blogs/delete",
  listQuestion: "/v1/admin/user-verification/questions",
  addQuestion: "/v1/admin/user-verification/add-question",
  editQuestion: "/v1/admin/user-verification/edit-question",
  changeStatusQuestion: "/v1/admin/user-verification/change-status-question",
  listSocialConnects: "/v1/admin/user-verification/social-connects",
  editSocialConnect: "/v1/admin/user-verification/edit-social-connect",
  changeStatusSocialConnect:
    "/v1/admin/user-verification/change-status-social-connect",
  postByUserId: "/v1/admin/post/postByUserId",
  postChangeStatus: "/v1/admin/post/change-status",
  districtList: "/v1/admin/location/districts",
  areaList: "/v1/admin/location/area",
  adminAreaList: "/v1/admin/location/admin-area",
  districtStatusChange: "/v1/admin/location/district/change-status",
  districtEdit: "/v1/admin/location/district",
  upazilaList: "/v1/admin/location/upazilas",
  upazilaStatusChange: "/v1/admin/location/upazila/change-status",
  upazilaEdit: "/v1/admin/location/upazila",
  unionList: "/v1/admin/location/unions",
  unionStatusChange: "/v1/admin/location/union/change-status",
  unionEdit: "/v1/admin/location/union",
  sellItemList: "/v1/admin/sell-items",
  sellItemStatusChange: "/v1/admin/sell-items/change-status",
  sellItemApprovalStatus: "/v1/admin/sell-items/approval-status",
  sellItemEdit: "/v1/admin/sell-items/item-edit",
  expertAdd: "/v1/admin/consultation/expert-add",
  consultationQueryList: "/v1/admin/consultation/queries",
  expertsList: "/v1/admin/consultation/experts",
  expertStatusChange: "/v1/admin/consultation/expert-status-change",
  expertEdit: "/v1/admin/consultation/expert-edit",
  expertDelete: "/v1/admin/consultation/expert-delete",
  consultationQueryReply: "/v1/admin/consultation/query-reply",
  reportReply: "/v1/admin/help-and-support/report-content/reply",
  deletePost: "/v1/admin/post/delete-post",
  sellItemByUserId: "/v1/admin/sell-items/item-list-by-user-id",
  soldItemByUserId: "/v1/admin/sold-items/item-list-by-user-id",
  buyItemByUserId: "/v1/admin/buy-items/item-list-by-user-id",
  sellItemAdd: "/v1/admin/sell-items/item-add",
  verifyUser: "/v1/admin/user/verify-user",
  getNotification: "/v1/admin/notifications/is-new-notification",
  getNotificationListAdmin: "/v1/admin/notifications/notification-list",
  fieldVisitRequestResponse: "/v1/admin/user/field-visit-response",
  downloadDistrictSampleFile: "/v1/admin/location/download-sample-csv-district",
  uploadDistrictCSVFile: "/v1/admin/location/upload-csv-district",
  downloadUpazilaSampleFile: "/v1/admin/location/download-sample-csv-upazila",
  uploadUpazilaCSVFile: "/v1/admin/location/upload-csv-upazila",
  downloadUnionSampleFile: "/v1/admin/location/download-sample-csv-union",
  uploadUnionCSVFile: "/v1/admin/location/upload-csv-union",
  userDetailsById: "/v1/admin/user/user-details",
  tutorialList: "/v1/admin/tutorial",
  tutorialChangeStatus: "/v1/admin/tutorial/change-status",
  tutorialDelete: "/v1/admin/tutorial/delete",
  serviceListData: "/v1/admin/services",
  backgroundList: "/v1/admin/background",
  backgroundChangeStatus: "/v1/admin/background/change-status",
  serviceProviderList: "/v1/admin/services/service-providers",
  serviceProviderChangeStatus:
    "/v1/admin/services/service-providers-change-status",
  serviceList: "/v1/admin/services/services",
  serviceProviderAdd: "/v1/admin/services/service-providers-add",
  serviceProviderEdit: "/v1/admin/services/service-providers-edit",
};

export default apiPath;
